interface Props {
  label: string;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
}

export const SecondaryButton = ({
  label,
  disabled,
  className,
  onClick,
  labelClassName = "text-droppie-oranje",
  ...rest
}: Props) => {
  return (
    <button
      disabled={disabled}
      {...rest}
      onClick={onClick}
      className={`${
        disabled ? "bg-gray-200" : "bg-white"
      }  bg-white border h-8 flex items-center justify-center border-droppie-oranje text-droppie-oranje hover:bg-droppie-oranje/5  px-6 py-2 rounded active:bg-gray-100 transition ease-linear ${className}`}
    >
      <p
        className={`font-satoshi font-medium text-dark text-base ${labelClassName}`}
      >
        {label}
      </p>
    </button>
  );
};
